import React from 'react';

const IconFilter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2 5H18" stroke="#111111" strokeWidth="1.5" />
    <path d="M4.5 10L15.5 10" stroke="#111111" strokeWidth="1.5" />
    <path d="M6.5 15L13.5 15" stroke="#111111" strokeWidth="1.5" />
  </svg>
);

export default IconFilter;
